import reduxConnector from 'root/src/shared/util/reduxConnector'
import submitsLoadingSelector from 'root/src/client/logic/form/selectors/submitsLoadingSelector'
import formType from 'root/src/client/logic/form/selectors/formType'
import customSubmitsDataSelector from 'root/src/client/logic/form/selectors/customSubmitsDataSelector'
import submitsFullWidth from 'root/src/client/logic/form/selectors/submitsFullWidth'
import submitsBlockSelector from 'root/src/client/logic/form/selectors/submitsBlockSelector'
import submitsRowSelector from 'root/src/client/logic/form/selectors/submitsRowSelector'
import formSubmits from 'root/src/client/logic/form/selectors/formSubmits'
import formSubmitError from 'root/src/client/logic/form/selectors/formSubmitError'
import postFormSubmits from 'root/src/client/logic/form/selectors/postFormSubmits'

import setSubmitsBlock from 'root/src/client/logic/form/thunks/setSubmitsBlock'
import submitForm from 'root/src/client/logic/form/thunks/submitForm'

export default reduxConnector(
	[
		['submitsLoading', submitsLoadingSelector],
		['formType', formType],
		['customSubmitsData', customSubmitsDataSelector],
		['submitsFullWidth', submitsFullWidth],
		['submitsBlock', submitsBlockSelector],
		['submitsRow', submitsRowSelector],
		['formSubmits', formSubmits],
		['formSubmitError', formSubmitError],
		['postFormSubmits', postFormSubmits],
	],
	[
		['setSubmitsBlock', setSubmitsBlock],
		['submitForm', submitForm],
	],
)
